import React from 'react';
import '../contacts/style.css';

function Privacy() {
    return (
        <div className="content fix-width contentPadding contactsPage">
            <h1>Политика обработки персональных данных</h1>
            <p>
                Настоящая Политика обработки персональных данных (далее — «Политика») составлена в соответствии
                с требованиями Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» и определяет
                порядок обработки персональных данных и меры по обеспечению их безопасности, принимаемые
                оператором персональных данных.
            </p>

            <h2>1. Оператор персональных данных</h2>
            <p>
                Оператором персональных данных является «DoLiKa» (далее — «Оператор»).
            </p>
            <p>
                Реквизиты оператора: [УКАЗАТЬ РЕКВИЗИТЫ ОПЕРАТОРА — ОГРН/ОГРНИП, ИНН, юридический адрес].
            </p>
            <p>
                Контактный email для связи по вопросам обработки персональных данных: {' '}
                <a href="mailto:manager@dolika.ru">manager@dolika.ru</a>.
            </p>

            <h2>2. Цели обработки персональных данных</h2>
            <p>Оператор обрабатывает персональные данные в следующих целях:</p>
            <ul>
                <li>оформление и выполнение заказа на оцифровку фото- и видеоматериалов;</li>
                <li>связь с клиентом для уточнения деталей заказа, информирования о его статусе и передачи результата;</li>
                <li>организация доставки готовых материалов клиенту.</li>
            </ul>

            <h2>3. Перечень обрабатываемых персональных данных</h2>
            <p>В рамках указанных целей Оператор обрабатывает следующие персональные данные:</p>
            <ul>
                <li>имя;</li>
                <li>номер телефона.</li>
            </ul>

            <h2>4. Правовые основания обработки персональных данных</h2>
            <p>
                Правовым основанием обработки персональных данных является согласие субъекта персональных
                данных на обработку его персональных данных, предоставляемое при оформлении заказа
                (п. 1 ч. 1 ст. 6 Федерального закона № 152-ФЗ «О персональных данных»).
            </p>

            <h2>5. Условия обработки и сроки хранения персональных данных</h2>
            <p>
                Обработка персональных данных осуществляется с использованием средств автоматизации и без
                использования таких средств, включая сбор, запись, систематизацию, накопление, хранение,
                уточнение, извлечение, использование, передачу (предоставление, доступ), обезличивание,
                блокирование, удаление и уничтожение персональных данных.
            </p>
            <p>
                Персональные данные хранятся не дольше, чем этого требуют цели их обработки, за исключением
                случаев, когда более длительный срок хранения предусмотрен законодательством Российской
                Федерации. Персональные данные подлежат уничтожению по достижении целей обработки или в
                случае отзыва субъектом персональных данных согласия на обработку.
            </p>

            <h2>6. Передача персональных данных третьим лицам</h2>
            <p>
                При выборе способа передачи материалов «Курьер» или «Почта» персональные данные (имя, телефон)
                могут передаваться курьерской либо почтовой службе в объёме, необходимом для осуществления
                доставки. Иным третьим лицам персональные данные не передаются, за исключением случаев,
                прямо предусмотренных законодательством Российской Федерации.
            </p>

            <h2>7. Права субъекта персональных данных</h2>
            <p>Субъект персональных данных имеет право:</p>
            <ul>
                <li>получать информацию, касающуюся обработки его персональных данных;</li>
                <li>требовать уточнения, блокирования или уничтожения своих персональных данных в случае, если они являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки;</li>
                <li>отозвать своё согласие на обработку персональных данных в любой момент;</li>
                <li>обжаловать действия или бездействие Оператора в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке.</li>
            </ul>
            <p>
                Для реализации указанных прав необходимо направить соответствующее обращение на email{' '}
                <a href="mailto:manager@dolika.ru">manager@dolika.ru</a>.
            </p>

            <h2>8. Меры по обеспечению безопасности персональных данных</h2>
            <p>
                Оператор принимает необходимые организационные и технические меры для защиты персональных
                данных от неправомерного или случайного доступа, уничтожения, изменения, блокирования,
                копирования, распространения, а также от иных неправомерных действий третьих лиц.
            </p>

            <h2>9. Заключительные положения</h2>
            <p>
                Оператор вправе вносить изменения в настоящую Политику. Новая редакция Политики вступает
                в силу с момента её размещения на данной странице.
            </p>
            <p>Дата последнего обновления документа: 15.08.2026.</p>
        </div>
    );
}

export default Privacy;
